<div [formGroup]="form" class="controls">
  <fb-date-picker-display [text]="form.controls.date.value | date: 'MM/dd/yyyy'" label="Date" />
  <fb-select
    formControlName="procedureType"
    placeholder="Select"
    label="Procedure Type"
    [compareWith]="compareLaserProcedureType"
    [markerTarget]="markerTarget()"
    markerFieldKey="procedureType"
    [rowIndex]="rowIndex()"
  >
    @for (option of procedureTypeOptions(); track option.id) {
      <ng-template fbSelectOption [fbSelectOptionValue]="option">
        {{ option.name }}
      </ng-template>
    }
  </fb-select>
  <fb-select
    formControlName="equipment"
    placeholder="Select"
    label="Equipment"
    [compareWith]="compareLaserEquipment"
    [markerTarget]="markerTarget()"
    markerFieldKey="equipment"
    [rowIndex]="rowIndex()"
  >
    @for (option of equipmentOptions(); track option.id) {
      <ng-template fbSelectOption [fbSelectOptionValue]="option">
        {{ option.name }}
      </ng-template>
    }
  </fb-select>
  <fb-text-field
    formControlName="serviceTime"
    label="Service Time"
    [mask]="masks.serviceTime"
    [markerTarget]="markerTarget()"
    markerFieldKey="serviceTime"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field
    formControlName="smartCool"
    [label]="smartCoolLabel()"
    [mask]="masks.smartCool"
    [markerTarget]="markerTarget()"
    markerFieldKey="smartCool"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field
    formControlName="joules"
    [label]="joulesLabel()"
    [mask]="masks.joules"
    [markerTarget]="markerTarget()"
    markerFieldKey="joules"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field
    formControlName="pulse"
    [label]="pulseLabel()"
    [mask]="masks.pulse"
    [markerTarget]="markerTarget()"
    markerFieldKey="pulse"
    [rowIndex]="rowIndex()"
  />
  <fb-text-field
    formControlName="repetitionRate"
    [label]="repetitionRateLabel()"
    [mask]="masks.repRate"
    [markerTarget]="markerTarget()"
    markerFieldKey="repetitionRate"
    [rowIndex]="rowIndex()"
  />
  <fb-select
    formControlName="firstLaserOption"
    [label]="firstLaserOptionLabel()"
    [compareWith]="compareLaserOption"
    [markerTarget]="markerTarget()"
    markerFieldKey="firstLaserOption"
    [rowIndex]="rowIndex()"
  >
    @for (option of firstLaserOptions(); track option.id) {
      <ng-template fbSelectOption [fbSelectOptionValue]="option">
        {{ option.text }}
      </ng-template>
    }
  </fb-select>
  <fb-select
    formControlName="secondLaserOption"
    [label]="secondLaserOptionLabel()"
    [compareWith]="compareLaserOption"
    [markerTarget]="markerTarget()"
    markerFieldKey="secondLaserOption"
    [rowIndex]="rowIndex()"
  >
    @for (option of secondLaserOptions(); track option.id) {
      <ng-template fbSelectOption [fbSelectOptionValue]="option">
        {{ option.text }}
      </ng-template>
    }
  </fb-select>
  <div class="notes">
    <label class="notes-label">
      <span class="notes-label__content">
        <span>Notes</span>
        <fb-scribe-suggestion-indicator [target]="markerTarget()" fieldKey="note"></fb-scribe-suggestion-indicator>
        <fb-amendment-field-indicator [rowIndex]="rowIndex()" fieldKey="note" />
      </span>
    </label>
    <textarea
      appPasteStrip
      appTextareaAutosize
      class="notes-textarea"
      formControlName="note"
      placeholder="Notes"
      [attr.maxlength]="noteMaxLength"
    ></textarea>
    @if (form.controls.note.hasError('maxlength') && (form.controls.note.dirty || form.controls.note.touched)) {
      <div class="notes-error">Ensure this field has no more than {{ noteMaxLength }} characters.</div>
    }
  </div>
</div>
